// extracted by mini-css-extract-plugin
export default {"header":"HeaderSimple_header__ck6rr","link":"HeaderSimple_link__vVTUg","linkSmall":"HeaderSimple_linkSmall__auYZW","inputSearch":"HeaderSimple_inputSearch__w7xmI"};